import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const classes = {
  root: css`
    margin-top: auto;
    position: relative;
  `,
  negative_margin: css`
    margin-bottom: ${spacing(-1)};
    marign-inline: ${spacing(-1)};
  `,
  min_margin: css`
    margin-top: ${spacing(2)};
  `,
}
